import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};

  & > header {
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0 1.5rem 0.5rem 1.5rem;
    border-radius: 0.25rem;
    margin: 0 auto 1rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    & > header {
      margin: 5rem auto 1rem;
    }
  }
`;

export const OrdersHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin: 1rem auto;

  .hefesto-input-wrapper__label-wrapper__label::after {
    content: '*';
    color: ${({ theme }) => theme.colors.purple};
  }

  > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto 1.5rem auto;
    padding: 0;
  }

  & h1 {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  & > .subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const MessageWithoutEmitter = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
